<template>
  <Icon :custom="customType" :size="size" />
</template>

<script>
import './style.css';
import '@/assets/iconfont/iconfont.css';
import '@/assets/niconfont/iconfont.css';

export default {
  name: 'LutticaIcon',
  props: {
    type: {
      required: true,
      default: '',
      type: String,
    },
    size: {
      default: 16,
      type: [Number, String],
    },
  },
  computed: {
    customType() {
      return `i-icon ${this.type}`;
    },
  },
};
</script>
